import type { JSX } from "preact";
import {
    CodeSlash,
    Justify,
    ListOl,
    ListUl,
    Quote,
    TextCenter,
    TextLeft,
    TextRight,
    TypeBold,
    TypeH1,
    TypeH2,
    TypeItalic,
    TypeStrikethrough,
    TypeUnderline,
} from "../components/icons";
import { AddImageButton } from "./AddImageButton";
import { AddLinkButton } from "./AddLinkButton";
import { AddTableButton } from "./AddTableButton";
import { BlockButton } from "./BlockButton";
import { ButtonDivider } from "./ButtonDivider";
import { MarkButton } from "./MarkButton";

export function Toolbar(): JSX.Element {
    return (
        <div className="text-editor-toolbar">
            <MarkButton type="bold" icon={TypeBold} />
            <MarkButton type="italic" icon={TypeItalic} />
            <MarkButton type="strikethrough" icon={TypeStrikethrough} />
            <MarkButton type="underline" icon={TypeUnderline} />
            <ButtonDivider />
            <BlockButton type="heading-one" icon={TypeH1} />
            <BlockButton type="heading-two" icon={TypeH2} />
            <ButtonDivider />
            <MarkButton type="code" icon={CodeSlash} />
            <BlockButton type="block-quote" icon={Quote} />
            <ButtonDivider />
            <BlockButton type="numbered-list" icon={ListOl} />
            <BlockButton type="bulleted-list" icon={ListUl} />
            <AddTableButton />
            <ButtonDivider />
            <BlockButton type="left" icon={TextLeft} />
            <BlockButton type="center" icon={TextCenter} />
            <BlockButton type="right" icon={TextRight} />
            <BlockButton type="justify" icon={Justify} />
            <ButtonDivider />
            <AddLinkButton />
            <AddImageButton />
        </div>
    );
}
